<template>
  <div class="event-card">
    <div class="event-card-inner">
      <div v-if="withTitle" class="event-header">
        <h3 class="event-title">{{ currentEvent.title.split("@")[0] }}</h3>
        <p v-if="currentEvent.metadata.caption" class="event-caption">{{ currentEvent.metadata.caption }}</p>
      </div>

      <div class="event-image-container">
        <template v-if="withLink">
          <router-link
            :to="
            currentEvent.metadata.magicEvent
              ? { path: currentEvent.metadata.link + '?event=' + currentEvent.slug }
              : { name: 'Event', params: { slug: currentEvent.slug } }
          "
            class="event-image-link"
          >
            <ResponsiveImage
              :image="currentEvent.metadata.main_image.imgix_url"
              :ws="imageDimensions.ws"
              :clamp="true"
              :hs="imageDimensions.hs"
              :wl="imageDimensions.wl"
              :hl="imageDimensions.hl"
              class="event-main-image"
            />
          </router-link>
        </template>
        <template v-else>
          <ResponsiveImage
            :image="currentEvent.metadata.main_image.imgix_url"
            :ws="imageDimensions.ws"
            :hs="imageDimensions.hs"
            :wl="imageDimensions.wl"
            :hl="imageDimensions.hl"
            class="event-main-image"
          />
        </template>
      </div>

      <div class="event-info">
        <EventBrand :title="currentEvent.title" class="event-brand" />
        <hr class="info-separator" />
        <EventVenue :title="currentEvent.title" :icon="true" class="event-venue" />
        <h4 class="event-time">
          {{  formattedDate }}
        </h4>
      </div>

<!--      <div v-if="withContent && currentEvent.content" class="event-content-body" v-html="currentEvent.content"></div>-->

      <div class="event-footer">
        <router-link
          v-if="!currentEvent.metadata.magicEvent"
          :class="currentEvent.loading && 'disabled'"
          :to="
            currentEvent.metadata.magicEvent
              ? { path: currentEvent.metadata.link + '?event=' + currentEvent.slug }
              : { name: 'Event', params: { slug: currentEvent.slug } }
          "
          class="btn btn-primary btn-sm event-details-button"
        >
          EVENT DETAILS
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import EventVenue from '@/components/EventCard/EventVenue';
import ResponsiveImage from '@/components/HeadImage/ResponsiveImage';
import EventBrand from '@/components/EventCard/EventBrand';
import { eventDateMixin } from '@/common/eventDateMixin';

export default {
  name: 'EventCard',
  mixins: [eventDateMixin],
  components: {
    EventBrand,
    EventVenue,
    ResponsiveImage,
  },
  props: {
    event: {
      type: Object,
    },
    idx: {
      type: Number,
    },
    withContent: {
      type: Boolean,
      default: false
    },
    withTitle: {
      type: Boolean,
      default: true
    },
    withLink: { // For image link
      type: Boolean,
      default: true
    },
    loadingProp: {
      type: Boolean,
      default: false
    },
    type: { // For router-link 'name'
      type: String,
      default: 'EventDetailsPage' // Example route name
    }
  },
  computed: {
    // Use a computed property to merge prop `event` with `loadingProp`
    // This avoids direct mutation of props and clarifies `loading` source
    currentEvent() {
      return {
        ...this.event,
        loading: this.loadingProp || this.event.loading // Prioritize prop or event's own loading state
      };
    },
    formattedDate() { // e.g., "2025-05-21 19:00"
      return this.attachPrettyDate(this.event.metadata.date + ' ' + this.event.metadata.start_time)
        ;
    },
    // Example dimensions, you might make these props or calculate them
    imageDimensions() {
      return { ws: '220', hs: '160', wl: '300', hl: '200' }; // Adjusted height for better aspect ratio with 300 width
    }
  }
};
</script>

